import * as React from 'react';

const SvgSms = (props) => (
  <svg
    viewBox='0 0 42 42'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M29.75 37.188h-17.5c-6.388 0-10.063-3.675-10.063-10.063v-12.25c0-6.387 3.675-10.063 10.063-10.063h17.5c6.388 0 10.063 3.676 10.063 10.063v12.25c0 6.388-3.675 10.063-10.063 10.063Zm-17.5-29.75c-5.005 0-7.438 2.432-7.438 7.437v12.25c0 5.005 2.433 7.438 7.438 7.438h17.5c5.005 0 7.438-2.433 7.438-7.438v-12.25c0-5.005-2.433-7.438-7.438-7.438h-17.5Z'
      fill='currentColor'
    />
    <path
      d='M21 22.522c-1.47 0-2.958-.455-4.095-1.382l-5.478-4.375c-.56-.455-.665-1.278-.21-1.838.455-.56 1.278-.665 1.838-.21l5.477 4.376c1.33 1.067 3.588 1.067 4.918 0l5.477-4.376c.56-.455 1.4-.367 1.838.21.455.56.367 1.4-.21 1.838l-5.478 4.375c-1.12.927-2.607 1.382-4.077 1.382Z'
      fill='currentColor'
    />
  </svg>
);

export default SvgSms;
